import { render, staticRenderFns } from "./BSelect.vue?vue&type=template&id=7f9d896b"
import script from "./BSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BSelect.vue?vue&type=style&index=0&id=7f9d896b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports